import React, { useState } from "react";

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    {
      url: "https://images.unsplash.com/photo-1473496169904-658ba7c44d8a?w=800",
      title: "Pontos Turísticos - Salvador",
      category: "Turismo"
    },
    {
      url: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800",
      title: "Construção Civil - Acompanhamento",
      category: "Obras"
    },
    {
      url: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800",
      title: "Imóveis de Luxo - Marketing",
      category: "Imóveis"
    },
    {
      url: "https://images.unsplash.com/photo-1518005068251-37900150dfca?w=800",
      title: "Mapeamento Aéreo - Georreferenciamento",
      category: "Mapeamento"
    },
    {
      url: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
      title: "Paisagens Naturais - Bahia",
      category: "Turismo"
    },
    {
      url: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800",
      title: "Vistoria de Fachadas",
      category: "Inspeção"
    }
  ];

  return (
    <section id="gallery" className="relative py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Galeria de Trabalhos
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-white mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">
            Conheça alguns dos nossos projetos realizados
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl cursor-pointer aspect-video bg-gray-900 hover:scale-105 transition-transform duration-300"
              onClick={() => setSelectedImage(image.url)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-3 py-1 bg-blue-600 text-white text-xs font-bold rounded-full mb-2">
                    {image.category}
                  </span>
                  <h3 className="text-white font-bold text-lg">{image.title}</h3>
                </div>
              </div>

              {/* Zoom Icon */}
              <div className="absolute top-4 right-4 bg-blue-600 p-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          {/* Close Button */}
          <button
            className="absolute top-8 right-8 text-white hover:text-blue-400 transition-colors z-50"
            onClick={() => setSelectedImage(null)}
          >
            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Image */}
          <div className="relative max-w-7xl max-h-[90vh] animate-scaleIn">
            <img
              src={selectedImage}
              alt="Gallery"
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Instructions */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-gray-400 text-sm">
            Clique fora da imagem para fechar
          </div>
        </div>
      )}
    </section>
  );
}
